import { render } from "./StudentDeshbord.vue?vue&type=template&id=aaa966ee"
import script from "./StudentDeshbord.vue?vue&type=script&lang=js"
export * from "./StudentDeshbord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__